import { render, staticRenderFns } from "./tradeApply.vue?vue&type=template&id=6e128d5a"
import script from "./tradeApply.vue?vue&type=script&lang=js"
export * from "./tradeApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports